(function () {
  function slideToggle(el, show, duration) {
    if (show) {
      el.style.display = 'block'; el.style.overflow = 'hidden'; el.style.height = '0';
      el.style.transition = 'height ' + duration + 'ms ease';
      requestAnimationFrame(function() { el.style.height = el.scrollHeight + 'px'; });
      setTimeout(function() { el.style.height = ''; el.style.overflow = ''; el.style.transition = ''; }, duration);
    } else {
      el.style.overflow = 'hidden'; el.style.height = el.offsetHeight + 'px';
      el.style.transition = 'height ' + duration + 'ms ease';
      requestAnimationFrame(function() { el.style.height = '0'; });
      setTimeout(function() { el.style.display = 'none'; el.style.height = ''; el.style.overflow = ''; el.style.transition = ''; }, duration);
    }
  }
  function initCollapsibleContent() {
    document.querySelectorAll('.collapsible-content__toggle').forEach(function(toggle) {
      toggle.onclick = function() {
        var parent = this.parentElement;
        var items = this.closest('.collapsible-content__items');
        if (!parent.classList.contains('active')) {
          if (items) items.querySelectorAll('.collapsible-content__item.active').forEach(function(a) { a.classList.remove('active'); });
          parent.classList.add('active');
          if (items) items.querySelectorAll('.collapsible-content__answer').forEach(function(a) { slideToggle(a, false, 300); });
          slideToggle(this.nextElementSibling, true, 300);
        } else {
          if (items) items.querySelectorAll('.collapsible-content__item.active').forEach(function(a) { a.classList.remove('active'); });
          if (items) items.querySelectorAll('.collapsible-content__answer').forEach(function(a) { slideToggle(a, false, 300); });
          parent.classList.remove('active');
          slideToggle(this.nextElementSibling, false, 300);
        }
      };
    });
  }
  document.addEventListener('shopify:section:load', initCollapsibleContent);
  initCollapsibleContent();
})();
